import {
  AttachMoney as AttachMoneyIcon,
  CalendarToday as CalendarTodayIcon,
  Category as CategoryIcon,
  LocalShipping as LocalShippingIcon,
  PauseCircleOutline as PauseCircleOutlineIcon,
  People as PeopleIcon,
  Place as PlaceIcon,
  ShoppingCart as ShoppingCartIcon,
  Speed as SpeedIcon,
} from '@mui/icons-material';

const menuItems = [
  {
    id: '/organizer_new',
    label: 'organizer',
    icon: CalendarTodayIcon,
    dataTestId: 'sideNavNewOrganizerBtn',
  },
  {
    id: '/map',
    label: 'map',
    icon: PlaceIcon,
    dataTestId: 'sideNavNewMapBtn',
  },
  {
    id: '/customers_new',
    label: 'customers',
    icon: PeopleIcon,
    dataTestId: 'sideNavCustomersNewBtn',
  },
  {
    id: '/products',
    label: 'products',
    icon: ShoppingCartIcon,
    dataTestId: 'sideNavProductsBtn',
  },
  {
    id: '/constructionCard',
    label: 'constructionCards',
    icon: CategoryIcon,
    dataTestId: 'sideNavNewMapBtn',
  },
  {
    id: '/deliveries',
    label: 'deliveries',
    icon: LocalShippingIcon,
    dataTestId: 'sideNavDeliveriesBtn',
  },
  {
    id: '/cascades',
    label: 'cascade',
    icon: AttachMoneyIcon,
    dataTestId: 'sideNavCascadeBtn',
  },
  {
    id: '/signals/await-for-invoice',
    label: 'awaitForInvoice',
    icon: PauseCircleOutlineIcon,
    dataTestId: 'sideNavAwaitForInvoice',
  },
  {
    id: 'https://scoring-client.prod.ironman.itlabs.io',
    label: 'scoringClient',
    icon: SpeedIcon,
    dataTestId: 'sideNavScoringClientBtn',
    isExternalUrl: true,
  },
];

export default menuItems;
